import React from "react";
var AlertContext = React.createContext({
  subtle: false
});
export default AlertContext;